
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vendor/invitation",
      function () {
        return require("private-next-pages/vendor/invitation.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vendor/invitation"])
      });
    }
  